import React from 'react';
import { BodyText, Container, Sheet } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { Message } from '@paypalcorp/worldready-react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { getComplaintsData } from '../../../jsV2/helpers/twHelper';

const complaintsData = getComplaintsData();

function BrexitComplaintsDataSheet(props) {
  const { complaintDataSheetTitle, isComplaintDataSheetOpen, handleSheetClose } = props;

  // Complaint Data from RC
  const bankingAndCreditcard = _get(complaintsData, 'bankingAndCreditcard', {});

  const renderComplaintsDataBrands = () => {
    if (Array.isArray(complaintsData.brandsOrTrading) && !_isEmpty(complaintsData.brandsOrTrading)) {
      return (
        <ul className="brexit_complaints_data__sheet__brand_ul" data-testid="brexit-complaints-data-sheet-brand-ul">
          {complaintsData.brandsOrTrading.map((brand) => (
            <li
              key={brand}
              className="brexit_complaints_data__sheet__brand_li"
              data-testid="brexit-complaints-data-sheet-brand-li"
            >
              <BodyText
                className="brexit_complaints_data__sheet__brand_li_text"
                data-testid="brexit-complaints-data-sheet-brand-li-text"
              >
                {brand}
              </BodyText>
            </li>
          ))}
        </ul>
      );
    }

    return (
      <span
        className="brexit_complaints_data__sheet__info__content"
        data-testid="brexit-complaints-data-sheet-info-content"
      >
        {complaintsData.brandsOrTrading}
      </span>
    );
  };

  const renderComplaintsDataSheetInfo = () => {
    return (
      <Container className="brexit_complaints_data__sheet__info" data-testid="brexit-complaints-data-sheet-info">
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid="brexit-complaints-data-sheet-info-text"
        >
          <Message id="smarthelp.complaints.complaintsData.sheet.firm" />
          <span
            className="brexit_complaints_data__sheet__info__content"
            data-testid="brexit-complaints-data-sheet-info-content"
          >
            {complaintsData.firmName}
          </span>
        </BodyText>
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid="brexit-complaints-data-sheet-info-text"
        >
          <Message id="smarthelp.complaints.complaintsData.sheet.group" />
          <span
            className="brexit_complaints_data__sheet__info__content"
            data-testid="brexit-complaints-data-sheet-info-content"
          >
            {complaintsData.group}
          </span>
        </BodyText>
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid="brexit-complaints-data-sheet-info-text"
        >
          <Message id="smarthelp.complaints.complaintsData.sheet.otherFirms" />
          <span
            className="brexit_complaints_data__sheet__info__content"
            data-testid="brexit-complaints-data-sheet-info-content"
          >
            {complaintsData.otherFrim}
          </span>
        </BodyText>
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid="brexit-complaints-data-sheet-info-text"
        >
          <Message id="smarthelp.complaints.complaintsData.sheet.period" />
          <span
            className="brexit_complaints_data__sheet__info__content"
            data-testid="brexit-complaints-data-sheet-info-content"
          >
            {complaintsData.periodCovered}
          </span>
        </BodyText>
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid="brexit-complaints-data-sheet-info-text"
        >
          <Message id="smarthelp.complaints.complaintsData.sheet.brands" />
          {renderComplaintsDataBrands()}
        </BodyText>
      </Container>
    );
  };

  const renderComplaintsDataSheetTable = () => {
    return (
      <table
        align="center"
        isFullWidth
        className="brexit_complaints_data__sheet__table"
        data-testid="brexit-complaints-data-sheet-table"
      >
        <thead className="brexit_complaints_data__sheet__table__header">
          <tr>
            <td />
            <th colSpan="2" className="brexit_complaints_data__sheet__table__top_header">
              <Message id="smarthelp.complaints.complaintsData.sheet.table.noComplaints" />
            </th>
          </tr>
          <tr className="brexit_complaints_data__sheet__table__header_row">
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.productService" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.provision" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.intermediation" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.noComplaintsOpened" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.noComplaintsClosed" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.percentClosedWithin3Days" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.percentClosedWithin8Weeks" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.percentUpheld" />
            </th>
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.mainCause" />
            </th>
          </tr>
        </thead>

        <tbody className="brexit_complaints_data__sheet__table__body">
          <tr className="brexit_complaints_data__sheet__table__body_row">
            <th>
              <Message id="smarthelp.complaints.complaintsData.sheet.table.bankingAndCreditcard" />
            </th>
            <td>{bankingAndCreditcard.provision}</td>
            <td>{bankingAndCreditcard.intermediation}</td>
            <td>{bankingAndCreditcard.noComplaintsOpened}</td>
            <td>{bankingAndCreditcard.noComplaintsClosed}</td>
            <td>{bankingAndCreditcard.percentClosedWithin3Days}</td>
            <td>{bankingAndCreditcard.percentClosedWithin8Weeks}</td>
            <td>{bankingAndCreditcard.percentUpheld}</td>
            <td>{bankingAndCreditcard.mainCause}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <Sheet
      data-testid="brexit-complaints-data-sheet"
      containerClassName="brexit_complaints_data__sheet_container"
      wrapperClassName="brexit_complaints_data__sheet_wrapper"
      className="brexit_complaints_data__sheet"
      title={complaintDataSheetTitle}
      isOpen={isComplaintDataSheetOpen}
      onCloseComplete={handleSheetClose}
      mobileFixedHeight="90"
      noPadding
      hideTitle
    >
      <Container className="brexit_complaints_data__sheet__content" data-testid="brexit-complaints-data-sheet-content">
        {renderComplaintsDataSheetInfo()}
        {renderComplaintsDataSheetTable()}
      </Container>
    </Sheet>
  );
}

BrexitComplaintsDataSheet.propTypes = {
  complaintDataSheetTitle: PropTypes.string.isRequired,
  isComplaintDataSheetOpen: PropTypes.bool.isRequired,
  handleSheetClose: PropTypes.func.isRequired,
};

export default BrexitComplaintsDataSheet;
